import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import VueCookie from 'vue3-cookies'
import VueYandexMetrika from 'vue-yandex-metrika-v3/dist/vue-yandex-metrika-v3'
import store from './store'
import '../public/css/main.css'
import "@fontsource/montserrat"
import "@fontsource/montserrat/400-italic.css" // Specify weight and style
import "@fontsource/montserrat/400.css" // Specify weight
import "@fontsource/montserrat/500.css" // Specify weight and style
import "@fontsource/montserrat/600.css" // Specify weight and style
import "@fontsource/montserrat/700.css" // Specify weight and style
import "@fontsource/montserrat/800.css" // Specify weight and style
import "@fontsource/montserrat/900.css" // Specify weight and style
import { checkIsProductionServer } from '@/helper'

const app = createApp({})

app.use(VueCookie)

app.config.productionTip = false

if (checkIsProductionServer()) {
  app.use(VueYandexMetrika, {
    id: process.env.VUE_APP_YandexMetrika,
    router: router,
    env: process.env.NODE_ENV
    // other options
  })
}

createApp(App)
  .use(router)
  .use(store)
  .use(vuetify)
  .use(VueCookie)
  .mount('#app')
